import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SharedProvider } from './StateManagement/Reducers/SharedReducer';
import { BrowserRouter } from 'react-router-dom';
import { loginRequest, authProvider } from './Helpers/AuthHelper';
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { MsalProvider } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import "./Theme/Theme.scss";
import "./Styles/Style.scss"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <MsalProvider instance={authProvider}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      //   errorComponent={<p>You are not signed in! Please sign in.</p>}
      //  loadingComponent={Loading}
      >
        <BrowserRouter>
          <SharedProvider>
            <App />
          </SharedProvider>
        </BrowserRouter>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
